export default "__VITE_ASSET__DwnxHGx5__"